<div [formGroup]="formGroup" [class]="data.classStyle">
  <mat-form-field>
    <mat-select [placeholder]="data.placeholder">
      @for (se of data.listSelect; track se) {
        <mat-option [value]="se">
          {{se}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>